<template>
  <div class="wrap">
    <template v-if="!(isPureType && !removePureItem)">
      <div v-if="isCustomSaleProp" class="wrap-item">
       <div class="wrap-item_label wrap-item_label-require">选择展示模式</div>
        <div class="wrap-item_content">
          <el-radio-group v-model="showMode" @change="showModeChange">
            <el-radio label="single-custom">单层·自定义规格</el-radio>
            <el-radio label="multi-select">分层·自选属性</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="wrap-item">
       <div class="wrap-item_label wrap-item_label-require">商品规格</div>
        <div class="wrap-item_content">
          <RuleSortBtn v-if="!isPureType" class="inline-block" :platform="platform" :specifications.sync="specifications" />
          <SpecsValuesSort v-if="!isPureType" :specifications.sync="specifications" />
          <div v-if="removePureItem" class="inline-block" style="margin-left: 10px;">
            <el-checkbox v-model="form.pureType" :true-label="1" :false-label="0">纯商品</el-checkbox>
            <el-tooltip effect="dark" content="勾选后支持纯商品发布，商品规格信息不生效" placement="top">
              <i class="el-icon-question help-icon" />
            </el-tooltip>
          </div>
          <FormItemSpecification v-if="!isPureType" v-model="specifications" :schemaSpecs="schemaSpecs" :showMode="showMode"/>
          <div v-if="validateSpecsErrorText" class="el-form-item__error" style="position: unset;margin-left: 0px !important;">{{ validateSpecsErrorText }}</div>
        </div>
      </div>
      <div v-if="!isPureType" class="wrap-item">
        <div class="wrap-item_label wrap-item_label-require">商品明细</div>
        <div class="wrap-item_content">
          <FormItemSkuList
            ref="skuListRef"
            :displayValueMaps="displayValueMaps"
            :specifications="specifications"
            :baseItemId="form.baseItemId"
            :imgOnlyPreview="skuImgOnlyPreview"
            :tableCols="skuTableCols"
            v-model="skuList"
            multipleSelection
            @inputChange="skuInputValidate"
            @selection-change="handleSkuSelectionChanged"
          >
            <template slot="sku_outerIdSlot" slot-scope="{ row, $index }">
              <el-input
                  v-model="row.sku_outerId"
                  readonly
                  @focus="handleProductMapping($index)"
              />
            </template>
            <template slot="skuBatchSlot">
              <el-button @click="handleBatchProductMapping">批量绑定商家编码</el-button>
            </template>
            <template slot="skuPictureSlot" slot-scope="{ row,$index }">
                <div style="padding: 8px 0;">
                    <ImgUpload
                      :width="80"
                      :ref="`search_img_${$index}`"
                      :height="80"
                      :aspectRatio="[1]"
                      aspectRatioText="1:1"
                      :limitSize="5 * 1024 * 1024"
                      :size="120"
                      :limitWidth="[1440, 0]"
                      :limitHeight="[1440, 0]"
                      :file="row.skuPicture"
                      :isSingle="true"
                      @upload-success="url => handleSearchImagesChanged(row, url,$index)"
                      @handleLoad="handleImgLoad(row, `search_img_${$index}`,$index)"
                      @del="() => handleSearchImagesChanged(row, '',$index)"
                    />
                </div>
            </template>
          </FormItemSkuList>
          <div v-if="validateSkuListErrorText" class="el-form-item__error" style="position: unset;margin-left: 0px !important;">{{ validateSkuListErrorText }}</div>
        </div>
      </div>
      <div class="wrap-item" v-if="!isPureType && stdSizeExtends && showMode !== 'single-custom'">
        <div class="wrap-item_label">尺码表</div>
        <div class="wrap-item_content">
          <el-button 
            :disabled="!TmStep3.form.std_size_group" 
            icon="el-icon-download" 
            plain 
            class="import-btn"
            @click="handleOpenTMImport"
          >
            从天猫后台快速导入尺码模板
          </el-button>
          <StdSizeExtends
            ref="StdSizeExtendsRef"
            :specifications="specifications"
            :schema="stdSizeExtends"
            :importData="importData"
          >
          </StdSizeExtends>
          <div v-if="validateStdListErrorText" class="el-form-item__error" style="position: unset;margin-left: 0px !important;">{{ validateStdListErrorText }}</div> 
        </div>
      </div>
    </template>
     <!-- 商品编码映射 -->
    <ProductMappingDialog
      ref="productMappingDialog"
      :baseItemId="form.baseItemId"
    />
     <!-- 导入尺码模板弹框 -->
    <ImportTemplateFromTm
      ref="importTemplateFromTm"
      :platform="platform"
      @on-success="handleImportTemplateSuccess"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {specification_mixin} from './Specifications/index'
import StdSizeExtends from './Specifications/StdSizeExtends.vue';
import Radio from '../Radio'
import RuleSortBtn from '@/components/prod/center/components/FormItemSpecification/RuleSortBtn.vue'
import SpecsValuesSort from '@/components/prod/center/components/FormItemSpecification/SpecsValuesSort.vue'

import { cloneDeep } from 'lodash';
import ProductMappingDialog from '@/components/prod/center/dialogs/ProductMappingDialog.vue';
import ImportTemplateFromTm from '@/components/prod/center/dialogs/ImportTemplateFromTm.vue';
import ImgUpload from "@/components/Uploads/ImgUpload";
import { genIsShowFn } from '../../utils/disableRule'

export default {
  components: {
    Radio,
    RuleSortBtn,
    SpecsValuesSort,
    ProductMappingDialog,
    StdSizeExtends,
    ImportTemplateFromTm,
    ImgUpload,
  },
  inject: {
    TmStep3: {
      default: {}
    },
    openSource:{default:null}
  },
  mixins: [specification_mixin],
  props: ["props", "form"],
  data() {
    return {
      platform: 'tm',
      schemaSpecs: [],
      skuSpecificationsKey: "skuSpecifications",
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      skuInputRules: {},
      self_form: {}, // 与别的平台不同，为了兼容使用规格组件，将skuList初始化到这个对象
      showMode: 'multi-select', // 展示模式
      oldSpecifications: [], // 旧规格
      // sizeGroupObj: null, // 尺码分组
      propsMap: {}, // 销售属性下的子属性索引
      skuParamsSchemas: [], // sku参数
      skuSearchImg:[], // sku搜索图相关
      needInitSp4StdSize: true,
      operateRowData: [],
      operateSkuIndex: -1,
      stdSizeExtends: {},
      importData: [],
      validateSpecsErrorText: '',
      validateSkuListErrorText: '',
      validateStdListErrorText: '',
    }
  },
  computed: {
    ...mapGetters(['removePureItem']),
    isPureType() {
      return this.form.pureType;
    },
    isCustomSaleProp() {
      return !!this.TmStep3?.schema?.customSaleProp;
    },
    skuTableCols() {
      let cols = [];
      if (!this.form.pureType || this.removePureItem) {
        const createColumn = (item,parentItem={}) => {
          let { name, label, rules } = item;
          const { requiredRule, tipRule } = rules || {};
          const input = this._genSkuInput(item);
          input.custom_validator = this._genSkuInputRules(name, rules, item);
          let openSource = this.openSource
          let isShowPreviewPrice = name === 'sku_price';
          if(['taskCenter','previewPublish'].includes(openSource)){
              isShowPreviewPrice = false
          }
          let obj = {
            prop: name,
            attrs: {
              label,
              width: 130,
              noRequired: requiredRule !== 'true',
              'header-tooltip': tipRule,
            },
            input,
            disabledFn: row => {
              const disabled = item.isShowFn ? !item.isShowFn(row) : false;
              if (disabled) row[name] = '';
              return disabled;
            },
            previewPrice: isShowPreviewPrice,
          }
          // 特殊处理商家编码
          if (name === 'sku_outerId') {
            return {
              prop: name,
              attrs: { label: '基础资料商家编码', width: 160, headerTooltip: '必填，用于关联基础资料规格明细'},
              input: { type: 'text', onlyTable: true },
              slot: true,
            };
          }

          // SKU搜索图处理
          if (parentItem.name === 'skuPicture') {
            obj.prop = 'skuPicture'
            obj.slot = true
          }
          if(parentItem.name === 'skuTitle'){ //SKU搜索标题
              obj.attrs.label = 'SKU搜索标题'
              obj.isCustomValidator = true
              obj.input.validator = (value,props,row) => {
                let _skuid = row._skuid;
                let errMsg = '字符长度控制在10~15个汉字（30个字符以内）'
                let index = this.skuList.findIndex(i => i._skuid === _skuid)
                if(value){
                    const chineseCharRegex = /[\u4e00-\u9fa5]/;
                    let totalLength = 0;
                    for (let i = 0; i < value.length; i++) {
                        // 如果是中文字符，计为2；否则计为1
                        totalLength += chineseCharRegex.test(value[i]) ? 2 : 1;
                        if (totalLength > 30) {
                           this.$set(this.skuList[index],'error_'+props.prop,errMsg)
                            return 'SKU搜索标题:'+errMsg;
                        }
                    }
                    if(totalLength < 10){
                      this.$set(this.skuList[index],'error_'+props.prop,errMsg)
                      return 'SKU搜索标题:'+errMsg;
                    }
                    this.$delete(this.skuList[index], 'error_'+props.prop)
                    return true
                }else{
                  this.$delete(this.skuList[index], 'error_'+props.prop)
                }
              }
          }
          if(['skuPicture','skuTitle'].includes(parentItem.name)){
              const { rules } = parentItem
              const { requiredRule, tipRule } = rules || {}
              obj.input.onlyTable = true
              if(!obj.attrs['header-tooltip']){
                obj.attrs['header-tooltip'] = tipRule
              }
          }
          return obj;
        };

        const EXCLUDE = ['sku_id', 'sku_quality']
        const children = this.props.dataSource.children || []
        const skuCols = children
          .filter(item => ((/^sku_/.test(item.name) || item.name === 'cspuId') && !EXCLUDE.includes(item.name)))
          .map(item => {
            if(this.TmStep3?.schema?.darwin_sku && ['sku_type','cspuId'].includes(item.name)){  // 手动加上达尔文sku时，SKU类型、产品规格 需要必填，不然铺货会报错
              item.rules = item.rules || {}
              item.rules.requiredRule = 'true'
            }
            if(item.name === 'sku_type' && Array.isArray(item.options)) {
              return { ...item, options: item.options.filter(option => option.value !== 'combine_cspu') }
            } 
            if(item.name === 'cspuId') {
              genIsShowFn(item);
            }
            return item
          }).map(createColumn).filter(Boolean)

        cols = [...skuCols];
        // skuParamsSchemas 处理逻辑 必填的放在前面
        const sortSkuParams = this.skuParamsSchemas.sort((a,b) => {
          let aRequired = a.rules?.requiredRule === 'true' ? 1 : 0;
          let bRequired = b.rules?.requiredRule === 'true' ? 1 : 0;
          if(a.children?.length){
            aRequired = a.children.some(item => item.rules?.requiredRule === 'true') ? 1 : 0
          }
          if(b.children?.length){
            bRequired = b.children.some(item => item.rules?.requiredRule === 'true') ? 1 : 0
          }
          return bRequired - aRequired
        }) 
        let skuParams = [...this.skuSearchImg,...sortSkuParams];
        skuParams.forEach(skuParam => {
          const disableRule = skuParam.rules?.disableRule;

          const processParam = (param,parentItem={}) => {
            const paramWithRules = {
              ...param,
              rules: { disableRule, ...param.rules },
            };
            genIsShowFn(paramWithRules);
            return createColumn(paramWithRules,parentItem);
          };

          if (skuParam.children?.length) {
            const childCols = skuParam.children.map(skuChildren => processParam(skuChildren,skuParam)).filter(Boolean);
            cols.push(...childCols);
          } else {
            const col = processParam(skuParam,skuParam);
            if (col) {
              cols.push(col);
            }
          }
        });
      }
     
      let findSku_outerIdIndex = cols.findIndex(item => item.prop === 'sku_outerId')
      if(findSku_outerIdIndex === -1) {
        findSku_outerIdIndex = 4
      }
      // 在 sku_outerId 后面插入 outSkuPlatform 列
      const outSkuPlatformCol = {
        prop: 'outSkuPlatform',
        attrs: {
          label: '平台规格编码',
          noRequired: true,
          width: 160,
          headerTooltip: '平台规格编码，对应平台sku外部商家编码，用于管理商品，并匹配ERP商品'
        },
        input: { type: 'text' }
      };
      cols.splice(findSku_outerIdIndex + 1, 0, outSkuPlatformCol);
      if(this.openSource === 'shopGoods'){
        cols = cols.filter(item => !['sku_outerId'].includes(item.name))
      }
      return cols;
    },
  },
  watch: {
    props: {
      immediate: true,
      handler(v) {
        this.showMode = this.isCustomSaleProp && (this.form.specifications || []).every(item => item.nameKey && item.nameKey.startsWith('custom_prop_')) ? 'single-custom' : 'multi-select'
        this.init()
      }
    },
    skuList(v) {
      this.valiSkuOuterId(v)
      let quantity = 0;
      v.map(item => quantity+= Number(item.sku_quantity))
      if(quantity != this.TmStep3.form.quantity) {
        this.TmStep3.form.quantity = quantity
      }
    }
  },
  methods: {
    init(specs){
      const v = this.props
      if(this.showMode === 'single-custom') {
        this.schemaSpecs = [{
          name: '商品规格',
          nameKey: 'custom_prop_1',
          ui: {
            label: '商品规格',
            name: 'custom_prop_1',
            type: "INPUT",
          }
        }]
      } else {
        this.schemaSpecs = v.dataSource.children.filter(item => /^(prop_|in_prop_)/.test(item.name)).map(item => ({
          name: item.label,
          nameKey: item.name,
          values: [],
          ui: item
        }))

      }
      this.oldSpecifications = cloneDeep(specs || this.form.specifications || [])
      this.initSome();
      this.method_initStdSize(this.form.std_size_group)
      this.stdSizeExtends = v.stdSizeExtends
    },
    handleSkuSelectionChanged(rowData) {
      this.operateRowData = rowData;
    },
    handleBatchProductMapping() {
      if (this.operateRowData.length === 0) {
        this.$message.warning('请先选择需要操作的sku');
        return false;
      }
      this.handleProductMapping(-1);
    },
    handleProductMapping(skuIndex) {
      this.operateSkuIndex = skuIndex;
      this.$refs.productMappingDialog.handleShow({
        onSuccess: (selectRowData) => {
          const { skuOuterId, id} = selectRowData;
          const selectList = this.operateSkuIndex === -1 ? this.skuList : [this.skuList[this.operateSkuIndex]]
          selectList.forEach(item => {
            item.sku_outerId = skuOuterId
            item.baseSkuId = id
          });
        },
        onCancel:() => {
          this.operateSkuIndex = -1;
        }
      });
    },
    initSome() {
      this.initPropsMap()
      this.initSpecifications()
      if(!this.form.pureType || this.removePureItem) {
        this.initSelfSkuList()
      }
      this.$nextTick(() => {
        this.validateSpecForm()
      })
    },
    showModeChange() {
      let specifications = cloneDeep(this.specifications);
      if(this.showMode === 'single-custom') {
        const singleCustomSpce = {
          checked: true,
          name: '商品规格',
          nameKey: 'custom_prop_1',
          values: [],
        } 
        const forEach = (arr, index = 0, c_arr = []) => {
          // 取到最后一层开始作业务逻辑
          if (arr.length === index) {
            let extendValues = {}
            let imageUrl = ''
            let value = c_arr.map((item, arrIndex) => {
              let _val = item.value || ''
              const { type, options } = specifications[arrIndex]?.ui || {}
              if (['SINGLECHECK', 'MULTICHECK'].includes(type) && options?.length) {
                const op = options.find(op => op.value === item.value)
                if(_val == -1 || !_val) {
                  _val = item.extendValues?.[`in_${item.valueKey}`] || item.extendValues?.[item.valueKey] || _val
                } else if(op) {
                  _val = op.displayName
                }
              } 
              delete item.extendValues?.[`in_${item.valueKey}`]
              delete item.extendValues?.[item.valueKey]
              if(arrIndex === 0) {
                extendValues = item.extendValues || {}
                imageUrl = item.imageUrl || ''
              }
              return _val
            }).join('')
            const valueKeys = c_arr.filter(item => !!item.valueKey).map(item => item.valueKey)
            let valuesItem = {
              name: '商品规格',
              nameKey: 'custom_prop_1',
              checked: true,
              value,
              valueKey: valueKeys.join('______'),
              imageUrl,
              extendValues: { ...extendValues}
            }
            singleCustomSpce.values.push(valuesItem)
            return
          }
          // 取出一层
          let currItem = arr[index]
          // 此层值循环
          currItem.values.forEach(c => {
            // 每个值再递归取
            forEach(arr, index + 1, c_arr.concat(c))
          })
        }
        forEach(specifications?.filter(item => item?.name));

        specifications = [singleCustomSpce]
      } else {
        specifications.forEach(item => {
          item.values.forEach(val => {
            delete val.valueKeys
          })
        })
      }
      this.init(specifications)
    },
    method_initStdSize(stdSize) {
      if (!stdSize || this.showMode === 'single-custom') return;
      const [sizeId, text, eText] = stdSize.split(':');

      let stdSizeSchema = this.props.dataSource.children.find(item => {
        const propid = item.name.replace(/(std_size_prop_)|(in_std_size_prop_)/, '').split('_')[0];
        return `std_size_prop_${propid}_${sizeId}_${eText}` ===  item.name
      })
      if (!stdSizeSchema) return;
      stdSizeSchema.rules =  {
        ...stdSizeSchema.rules,
        allowCreate: !!this.props.dataSource.children.find(i => i.name === `in_${stdSizeSchema.name}`)}
     
      // 构造规格对象
      const stdSpec = {
        name: stdSizeSchema.label,
        nameKey: stdSizeSchema.name,
        values: [],
        ui: stdSizeSchema
      }
      // 更新或插入到 specifications
      const updateOrPush = (arr, matcher, value) => {
        const idx = arr.findIndex(matcher);
        if (idx > -1) arr[idx] = value;
        else arr.push(value);
      };
      updateOrPush(this.specifications, ({ nameKey }) => /^std_size_prop/.test(nameKey), stdSpec);
      updateOrPush(this.schemaSpecs, ({ nameKey }) => /^std_size_prop/.test(nameKey), cloneDeep(stdSpec));

      if (this.needInitSp4StdSize) {
        this.needInitSp4StdSize = false
        // 初始化情况下，要将原始数据中的规格数据复制到form表单
        this.form.specifications = this.TmStep3.oriDatas[0].specifications
      }
      this.initSome();

    },
    // sku中的控件输入回调 做一些校验的事
    skuInputValidate(row, prop) {
      this.skuInputRules[prop] && this.skuInputRules[prop](row)
    },
    _genSkuInputRules(prop, rules, item) {
      const {maxValueRule, requiredRule, regexRule} = rules || {}
      const errorProp = `error_${prop}`
      const validator = (row) => {
        if(requiredRule === 'true' && item.type === 'SINGLECHECK') {
          if(!row[prop]) {
            this.$set(row, errorProp, `必填`)
            return false
          }
        }
        if(requiredRule === 'true' && item.type === 'MULTICHECK') {
          if(!row[prop] || row[prop].length === 0) {
            this.$set(row, errorProp, `必填`)
            return false
          }
        }
        let _value = String(row[prop] === null ? '' : row[prop])
        if (requiredRule === 'true') {
          if (!_value && _value !== 0) {
            this.$set(row, errorProp, `必填`)
            return false
          }
        }
        if (regexRule) {
          let reg = new RegExp(`^${regexRule}$`)
          if (!reg.test(_value)) {
            this.$set(row, errorProp, `请填入正确的格式：${regexRule}`)
            return false
          }
        }
        if (maxValueRule) {
          if (Number(_value) > Number(maxValueRule)) {
            this.$set(row, errorProp, `最大值：${maxValueRule}`)
            return false
          }
        }
        this.$set(row, errorProp, '')
        return true
      }
      this.skuInputRules[prop] = validator
      return validator
    },
    // 生成skuList的输入控件属性
    _genSkuInput(item) {
      if (['SINGLECHECK', 'MULTICHECK'].includes(item.type)) {
        return {type: 'select', options: item.options, attrs: {filterable: true, clearable: true, multiple: item.type === 'MULTICHECK'}}
      } else if (item.type !== 'INPUT') {
        return { type: 'text' }
      }
      let input = null
      const rules = item.rules || {}
      const numUnitObj = this.parseNumberUnit(rules.tipRule)

      if (["long", "decimal", 'integer'].includes(rules.valueTypeRule)) {
        input = {type: 'number'}
        if (['long', 'integer'].includes(rules.valueTypeRule)) {
          input.attrs = { precision: 0 }
        } else if(['decimal'].includes(rules.valueTypeRule)) {
          input.attrs = { precision: 2 }
        }
      } else if (numUnitObj) {
        input = { type: numUnitObj.inputType === 'text' ? 'text' : 'number' }
        input.attrs = {
          precision: typeof numUnitObj.precision === 'number' ? numUnitObj.precision : '',
          append: numUnitObj.unit,
        }
      } else if (["date"].includes(rules.valueTypeRule)) {
        input = {type: 'date', attrs: {
          "value-format": "yyyy-MM-dd",
          "clearable": true,
          "placeholder": "选择日期"
        }}
      } else {
        input = {type: 'text'}
      }
      return input
    },
    parseNumberUnit(tipRule) {
      // 吊牌价格式为 :值单位，单位为元，输入的值必须为整数
      // 弹性指数格式为 :值单位，单位为%，小数点后最多保留1位.
      // 总净含量格式为 :值单位，单位为kg|g，小数点后最多保留2位.  （多个单位的）
      // 腰围尺寸格式为 :值-值单位，单位为cm，输入的值必须为整数
      // "尺寸格式为 :值x值单位，单位为cm|mm，输入的值必须为整数"
      if (!tipRule) return null
      let inputType = 'number'
      const multiPattern = /值\s*[-xX×~*/]\s*值单位/.test(tipRule)
      if (multiPattern) {
        inputType = 'text'
      }
      const unitMatch = tipRule.match(/单位为[:：]?\s*([^\s，。；]+)/)
      const unit = unitMatch ? unitMatch[1] : undefined
      let precision
      const decimalLimit = tipRule.match(/小数点后最多保留(\d+)位/)
      if (decimalLimit) {
        precision = Number(decimalLimit[1])
      } else if (/输入的值必须为整数|必须为整数/.test(tipRule)) {
        precision = 0
      }
      if (!unit && precision === undefined) return null
      return { unit, precision, inputType }
    },
    // 验证商家编码是否匹配
    valiSkuOuterId(skuList) {
      if(this.form.pureType) return true;
      if (skuList && skuList.length) {
        if (!skuList[0].sku_outerId) {
          this.$message.error('商品明细：商家编码匹配必填，请维护商家编码')
          return false
        }
        return true
      }
      return true
    },
    // 初始化子属性索引
    initPropsMap() {
      let propsMap = {}
      let skuQuality = null
      let skuParamsSchemas = []
      let skuSearchImg = []
      if(this.showMode ==='single-custom') {
        propsMap = {
          '商品规格': {
            propId: '',
            values: [],
            children: []
          }
        }
        // this.propsMap = propsMap
        // this.skuParamsSchemas = skuParamsSchemas  // // 初始化sku参数
        // this.skuSearchImg = skuSearchImg;
        // return
      }
      this.props.dataSource.children.forEach(item => {
        if(/^(prop_|in_prop_|std_size_prop_)/.test(item.name)) {
          propsMap[item.label] = {
            propId: item.name,
            values: item.options,
            children: item.children
          }
        } else if(item.name === 'sku_quality') {  // sku参数
          skuQuality = item
        } else if(item.name.startsWith('skuParam_')) {
          skuParamsSchemas.push(item)
        }else if(['skuPicture','skuTitle'].includes(item.name)){
          skuSearchImg.push(item)
        }
      })
      if(skuQuality) {
        skuParamsSchemas.unshift(skuQuality)
      } else {
        skuParamsSchemas = []
      }
      this.propsMap = propsMap
      this.skuParamsSchemas = skuParamsSchemas  // // 初始化sku参数
      this.skuSearchImg = skuSearchImg;
    },
    // 赋予默认规格值
    action_defaultSpValues(_specification, defalueValues, isSizeGroup) {
      if (['SINGLECHECK', 'MULTICHECK'].includes(_specification.ui.type)) {
        // 若规格值是下拉选择类型，则要比对defalueValues,找出对应_specification.ui.options中的id,找不到则置空
        const { nameKey } = _specification;
        const {options, name} = _specification.ui
        _specification.values = defalueValues.map(d => {
          let op = null
          // 默认值不是数字，就与displayName去匹配 
          // 否则与value匹配
          op = (options || []).find(o => {
            // 只有当尺码分组有值且当前规格是尺码分组中引出的规格（以std_size_prop_）才直接用value相等判断，否则走老逻辑匹配
            // fix: KMERP-115608 规格有空值后选择尺码分组导致卡死问题修复
            if (isSizeGroup && /^std_size_prop_/.test(name)) {
              if (d.value == -1) {
                return o.displayName === d.extendValues[`in_${name}`];
              } else if (o.displayName === d.value) {
                return o.displayName === d.value;
              }
              return o.value === d.value
            } else {
              return isNaN(Number(d.value)) ? o.displayName === d.value : o.value === d.value
            }
          });
          let value = op ? op.value : d.value;
          const valueItem = {
            ...d,
            value,
            nameKey,
            name: _specification.name || d.name,
            extendValues:  {...d.extendValues, }
          };
          // 值为-1的时候，则
          if ((value == -1 || !value) && (valueItem.extendValues[`in_${nameKey}`] || valueItem.extendValues[nameKey])) {
            valueItem.trueValue = -1;
            valueItem.value = valueItem.extendValues[`in_${nameKey}`] || valueItem.extendValues[nameKey];
          } else if (!op) {
            valueItem.trueValue = -1;
            valueItem.extendValues[`in_${nameKey}`] = value;
            valueItem.value = value;
          }
          return valueItem;
        })
      } else {
        _specification.values = defalueValues
      }
    },
    // 提取规格排序逻辑
    sortSpecificationsByPropImage(specifications) {
      if (specifications.length > 1) {
        const hasPropImageIndex = specifications.findIndex(({nameKey}) => 
          this.$store.getters.tmExtendsFields[nameKey]?.some(({name}) => name === "prop_image")
        );
        if (hasPropImageIndex > -1) {
          const [hasPropImagItem] = specifications.splice(hasPropImageIndex, 1);
          specifications.unshift(hasPropImagItem);
        }
      }
      return specifications;
    },

    // 处理匹配的规格
    handleMatchedSpecification(specification, existSp, isSizeGroup) {
      specification.extendValues = existSp.extendValues;
      this.action_defaultSpValues(specification, existSp.values, isSizeGroup);
    },

    // 处理未匹配的规格
    handleUnmatchedSpecification(specification, specifications, canUseSpecificationsIndex, isSizeGroup) {
      if (canUseSpecificationsIndex.length < 1) {
        const { rules = {} } = specification.ui || {};
        if (rules?.requiredRule === 'true') {
          this.action_defaultSpValues(specification, [{
            checked: true,
            name: "",
            nameKey: "",
            orderId: 999,
            value: "无规格",
            valueKey: '',
          }], isSizeGroup);
        } else {
          return null;
        }
      } else {
        const canUseIndex = canUseSpecificationsIndex.shift();
        this.action_defaultSpValues(specification, specifications[canUseIndex].values, isSizeGroup);
      }
      return specification;
    },

    // 初始化规格方法
    initSpecifications() {
      const isSizeGroup = !!this.form.std_size_group;
      let specifications = this.oldSpecifications
      let canUseSpecificationsIndex = specifications.map((_, index) => index);
      // 当前规格信息
      let curr_specifications = this.sortSpecificationsByPropImage(JSON.parse(JSON.stringify(this.schemaSpecs)));
      const noMatchSpIndexArr = [];
      curr_specifications.forEach((specification, index) => {
        const existSpIndex = specifications.findIndex(item => item.name === specification.name);
        if (existSpIndex > -1) {
          canUseSpecificationsIndex = canUseSpecificationsIndex.filter(i => i !== existSpIndex);
          this.handleMatchedSpecification(specification, specifications[existSpIndex], isSizeGroup);
        } else {
          noMatchSpIndexArr.push(index);
        }
      });
      // const isRequiredMatch = noMatchSpIndexArr.some(index => curr_specifications[index].ui?.rules?.requiredRule)
      // 没有可使用的规格，且没有必填的规格, 则默认第一个规格为必填，使其最少生成一个规格
      if(noMatchSpIndexArr.length) {
        // if(canUseSpecificationsIndex.length < 1 && !isRequiredMatch) {
        //   curr_specifications[noMatchSpIndexArr[0]].ui.rules.requiredRule = 'true';
        // }
        noMatchSpIndexArr.forEach(index => {
          const result = this.handleUnmatchedSpecification(
            curr_specifications[index],
            specifications,
            canUseSpecificationsIndex,
            isSizeGroup
          );
          if (!result) {
            curr_specifications[index] = null;
          }
        });
      }
      this.specifications = curr_specifications.filter(Boolean);
    },
    initSelfSkuList() {
      const formSkuList = cloneDeep(this.form.skuList) || [];
      const findSkuTypeItem = (this.props.dataSource.children || []).find(item => item.name === 'sku_type')
      let _skuList = formSkuList.map(item => {
        if(findSkuTypeItem) {
          item.sku_type = 'cspu'
        }
        const skus = JSON.parse(item['skuSpecifications']) || [];
        const valueKeys = skus.filter(sp => sp.valueKey).map(sp => sp.valueKey)
        // 处理sku参数
        let skuParams = [...this.skuParamsSchemas,...this.skuSearchImg];
        skuParams.forEach(skuParam => {
          const skuFieldDescriptorList = item.skuFieldDescriptorList || []
          const findItem = skuFieldDescriptorList.find(skuField => skuField?.name === skuParam?.name) || {}
          
          if (skuParam?.children?.length) {
            skuParam.children.forEach(skuParamChild => {
              const childList = findItem.children || []
              const childFindItem = childList.find(child => child?.name === skuParamChild?.name) || {}
              this.parseSetValue(skuParamChild, childFindItem.defaultValue, item)
            })
          } else if (skuParam?.name) {
            this.parseSetValue(skuParam, findItem.defaultValue, item)
          }
        })
        return {
          ...item,  
          valueKeys,          
          skuSpecifications: skus,
          _skuid: valueKeys.join('-'),
        }
      })
      this.self_form.skuList = _skuList
    },
    parseSetValue(propItem, defaultValue, item) {
      const { type, name, label, rules, options } = propItem
      let val = defaultValue || null
      if(type === 'MULTICHECK') {
        try {
          if(!defaultValue) {
            val = []
          }
          const parsedValue = JSON.parse(defaultValue)
          val = Array.isArray(parsedValue) ? parsedValue : [];
        } catch (error) {
          val = []
        }
      } 
      const numberUnit = this.parseNumberUnit(rules?.tipRule)
      if(numberUnit) {
        // 处理单位, 如 val为 5.3kg, 提取单位kg
        // 如val为30x120cm,拆分为值为30x120,单位为cm
        if(numberUnit?.unit.includes('|')) {
          const unitOpts = numberUnit.unit.split('|').filter(Boolean)
          const sVal = typeof val === 'string' ? val : ''
          // 按长度降序排序，优先匹配更长的单位（如 'cm' 优先于 'm'）
          const sortedUnits = [...unitOpts].sort((a, b) => b.length - a.length)
          const matchedUnit = sortedUnits.find(u => sVal.endsWith(u))
          item[`${name}_unit`] = matchedUnit || unitOpts[0]
        } 
        if(numberUnit?.inputType === 'number') {
          val = (val || '').replace(/[^\d.]/g, '')
        } else {
          const sVal = typeof val === 'string' ? val : ''
          if (sVal) {
            const unitStr = numberUnit.unit || ''
            const unitOpts = unitStr.includes('|') ? unitStr.split('|').filter(Boolean) : [unitStr].filter(Boolean)
            // 按长度降序排序，优先匹配更长的单位（如 'cm' 优先于 'm'）
            const sortedUnits = [...unitOpts].sort((a, b) => b.length - a.length)
            const matchedUnit = sortedUnits.find(u => sVal.endsWith(u))
            val = matchedUnit ? sVal.slice(0, -matchedUnit.length).trim() : sVal
          }
        }
      }
      if(propItem.label.includes('SKU搜索主图')){
        item['skuPicture'] = val
      } else {
        item[name] = ['MULTICHECK', 'SINGLECHECK'].includes(type) ? this.fliterValInOptions(options, val) : val
      }
    },
    // 单选，多选，不在其选项中的值，直接过滤掉
    fliterValInOptions(options, val){
      if(!options?.length) return val
      let newVal;
      if(Array.isArray(val)) {
        newVal = val.filter(v => options.some(op => op.value === v))
      } else {
        newVal = options.some(op => op.value === val) ? val : ''
      }
      return newVal
    },
    validateSpecForm() {
      this.validateSpecsErrorText = ''
      this.validateSkuListErrorText = ''
      this.validateStdListErrorText = ''
      if (!this.valiSkuOuterId(this.skuList)) {
        return false
      }
      if (!this.validateSpecifications()) {
        this.validateSpecsErrorText = '请完善商品规格'
        return false
      }
      if (!this.validateSkuList()) {
        this.validateSkuListErrorText = '请完善商品明细'
        return false
      }
       if (!this.validateStdList()) {
        this.validateStdListErrorText = '请完善尺码表'
        return false
      }
      return true
    },
    // 获取相关数据
    method_getData() {
        if(this.form.pureType) return true;
        if(!this.validateSpecForm()) {
          return false
        }
        let [specifications, skuList] = this.getSpecificationData()

        // 处理specifications中的values值，将propsMap中的value一一对应，若没有对应的，从-2开始自减作为自定义的value
        let _valueId = -2
        specifications.forEach(sp => {
          const isSelectType = ['SINGLECHECK', 'MULTICHECK'].includes(sp.ui.type)
          const oriOptions = cloneDeep(sp.ui.options || [])
          const options = this.propsMap[sp.name].values || []
          let propId = ''
          if (/^std_size_prop_/.test(this.propsMap[sp.name].propId)) {
            propId = this.propsMap[sp.name].propId.replace(/^std_size_prop_(\d+).*/, '$1')
          } else {
            propId = this.propsMap[sp.name].propId.replace(/^(prop_|in_prop_)/, '').split('_')[0]
          }
          
          sp.values.forEach(spv => {
            spv.valueKey = spv.valueKey || spv.value
            const existOption = options && options.find(op => isSelectType ? op.value == spv.value : op.displayName == spv.value)
            if (existOption) {
              spv.propValueId = existOption.value
              spv.value = isSelectType ? existOption.value : spv.value
            } else {
              spv.propValueId = _valueId--
              options.push({displayName: spv.value, value: spv.propValueId})
            }
            spv.propId = propId
            if(isSelectType) { 
              if (!spv.extendValues) {
                spv.extendValues = {}
              }
              // 判断选中的值是否在oriOptions可选项中，若不在则是手动输入的值，需要把值匹配到像in_prop_1627207(当前项为prop_1627207)的扩展属性里
              const value = spv.value === -1 && spv.extendValues[`in_${sp.nameKey}`] ? spv.extendValues[`in_${sp.nameKey}`] : spv.value;
              const findItem = oriOptions.find(op => op.value == value || op.displayName == value);
              if(findItem) {
                spv.value = findItem.value;
                spv.propValueId = findItem.value;
                delete spv.extendValues[`in_${sp.nameKey}`]
                delete spv.extendValues[sp.nameKey]
              } else {
                spv.extendValues[`in_${sp.nameKey}`] = spv.value;
                spv.value = '-1';
              }
              delete spv.trueValue;
            }
            // 删除多余的一些属性
            // Object.keys(spv.extendValues).forEach(key => {
            //   if (![spv.nameKey, `in_${spv.nameKey}`].includes(key)) {
            //     delete spv.extendValues[key];
            //   }
            // })
          })
        })
        // skuList中的skuSpecifications也需要加入propValueId, propId
        skuList.forEach(sku => {
          sku.skuSpecifications.forEach((skuSp, skuSpIndex) => {
            if (skuSpIndex === 0) {
              // 取第一规格的图片赋给sku外层
              sku.imageUrl = skuSp.imageUrl
            }
            skuSp.valueKey = skuSp.valueKey || skuSp.value
            if(!specifications[skuSpIndex]) return
            const isSelectType = ['SINGLECHECK', 'MULTICHECK'].includes(specifications[skuSpIndex].ui.type)
            const options = this.propsMap[specifications[skuSpIndex].name].values || []
            const existOp = options.find(op => isSelectType ? op.value === skuSp.value : op.displayName === skuSp.value)
            if (existOp) {
              skuSp.propValueId = existOp.value
            }
            if (/^std_size_prop_/.test(this.propsMap[specifications[skuSpIndex].name].propId)) {
              skuSp.propId = this.propsMap[specifications[skuSpIndex].name].propId.replace(/^std_size_prop_(\d+).*/, '$1')
            } else {
              skuSp.propId = this.propsMap[specifications[skuSpIndex].name].propId.replace(/^(prop_|in_prop_)/, '').split('_')[0]
            }
          })
          sku.skuSpecifications = JSON.stringify(sku.skuSpecifications);
          sku.skuFieldDescriptorList = sku.skuFieldDescriptorList ? [...sku.skuFieldDescriptorList] : [];
          const needSkuFieldDescriptorList = ['outSkuPlatform', 'cspuId'];
          const skuFieldNames = []
          Object.keys(sku).filter(key => /^sku_/.test(key) || needSkuFieldDescriptorList.includes(key)).forEach(key => {
            const matchField = sku.skuFieldDescriptorList.find(attr => attr.name === key);
            if (matchField) {
              matchField.defaultValue = sku[key]
            } else {
              sku.skuFieldDescriptorList.push({
                id: null,
                name: key,
                label: null,
                dataId: null,
                defaultValue: sku[key],
                type: null,
                rules: null,
                options: null,
                children: null
              })
            }
            skuFieldNames.push(key)
            delete sku[`error_${key}`]
          })
          // 处理sku参数
          let skuParams = [...this.skuParamsSchemas,...this.skuSearchImg]
          skuParams.map(skuParam => {
            const skuParamItem = {
              name: skuParam.name,
              defaultValue: this.transformDefaultValue(skuParam, sku[skuParam.name], sku)
            };
            skuFieldNames.push(skuParam.name)
            if(skuParam.children?.length) {
              skuParamItem.children = skuParam.children.map(skuParamChild => {
                let valueKey = skuParamChild.name
                if(skuParam.name === 'skuPicture'){// sku搜索图特殊处理
                    valueKey = 'skuPicture'
                }
                const childItem = {
                  name: skuParamChild.name,
                  defaultValue: this.transformDefaultValue(skuParamChild, sku[valueKey], sku)
                };
                skuFieldNames.push(skuParamChild.name)
                return childItem;
              });
            }
            const findIndex = sku.skuFieldDescriptorList.findIndex(skuField => skuField.name === skuParam.name)
            if(findIndex > -1) {
              sku.skuFieldDescriptorList.splice(findIndex, 1, skuParamItem)
            } else {
              sku.skuFieldDescriptorList.push(skuParamItem)
            }
          });
          skuFieldNames.forEach(name => {
            delete sku[name]
            delete sku[`${name}_unit`]
          })
        })
        // 删除多余参数ui
        specifications.forEach(item => {
          delete item.ui
        })
        return [specifications, skuList]
    },
    transformDefaultValue(prop, value, sku) {
      if (prop.type === 'MULTICHECK') {
        try {
          return Array.isArray(value) ? JSON.stringify(value) : '';
        } catch (error) {
          return '';
        } 
      } 
      const numberUnit = this.parseNumberUnit(prop?.rules?.tipRule)
      if(value !== '' && value !== null && value !== undefined && numberUnit?.unit) {
        if(numberUnit.unit.includes('|')){
          return value + (sku[`${prop.name}_unit`] || numberUnit.unit.split('|')[0])
        } else {
          return value + numberUnit.unit
        }
      }
      return value || null;
    },

    // 从天猫后台快速导入尺码模板
    handleOpenTMImport(){
      this.$refs.importTemplateFromTm.handleShow();
    },
    handleImportTemplateSuccess(data) {
      this.importData = data
    },
    handleSearchImagesChanged(row,url,index){
      if(!url){
        this.$delete(this.skuList[index], 'error_skuPicture')
      }
      this.$set(this.skuList[index],'skuPicture',url)
    },
    async handleImgLoad(row, refName,index) {
      let errMsg = await this.$refs[refName].method_validImage()
      if(errMsg){
        this.$refs.skuListRef.changeListItem(index,'error_skuPicture',errMsg)
        // this.$set(this.skuList[index],'error_skuPicture',errMsg)
      }else{
        this.$refs.skuListRef.changeListItem(index,'error_skuPicture')
        // this.$delete(this.skuList[index], 'error_skuPicture')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  .wrap-item {
    display: flex;
    .wrap-item_label {
      width: 12%;
      font-size: 12px;
      padding-right: 6px;
      text-align: right;
      flex-shrink: 0;
    }
    .wrap-item_label-require {
      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
        box-sizing: border-box;
      }
    }
    .wrap-item_content {
      flex: 1;
      overflow: hidden;
    } 
    .import-btn{
      margin-bottom: 10px;
      color: #396CF3;
    }
    .import-btn:hover{
      margin-bottom: 10px;
      background: #396CF3;
      color: white;
    }
  }
  .wrap-item + .wrap-item {
    margin-top: 20px;
  }
}

</style>
